import classnames from 'classnames';
import { type ReactNode } from 'react';

import Info from '@/components/Icons/Info';

import Button from '../Button';

import s from './BannerStatus.module.scss';

const BannerStatus: React.FC<{
  status: 'success' | 'error' | 'warning' | 'info';
  label: string;
  description?: string;
  indent?: boolean;
  className?: string;
  compact?: boolean;
  cta?: {
    label: string;
    icon?: ReactNode;
    onClick: () => void;
  };
}> = ({ className, indent, status, label, description, compact, cta }) => (
  <div
    className={classnames(
      indent && s.bannerIndent,
      status === 'error' && s.bannerError,
      status === 'warning' && s.bannerWarning,
      status === 'success' && s.bannerSuccess,
      status === 'info' && s.bannerInfo,
      compact && s.bannerCompact,
      className,
    )}
  >
    <Info
      size={16}
      weight='fill'
      color={
        (status === 'error' && 'var(--color-error)') ||
        (status === 'warning' && 'var(--color-warning)') ||
        (status === 'info' && 'var(--color-info)') ||
        'var(--color-success)'
      }
    />
    <div className={s.lines}>
      {label.split('\n').map((line, idx) => (
        <span key={`${line}-${idx}`} style={description ? { fontWeight: 'bold' } : undefined}>
          {line}
        </span>
      ))}
      {description && <span>{description}</span>}
    </div>
    {cta && (
      <Button variant='secondary' size='sm' onClick={cta.onClick}>
        <span className='inline-flex items-center gap-2'>
          {cta.icon}
          {cta.label}
        </span>
      </Button>
    )}
  </div>
);

export default BannerStatus;
